"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _constants = require("../constants");
var _typography = _interopRequireDefault(require("./typography"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledRadio = (0, _styledComponents["default"])(_Radio["default"]).withConfig({
  displayName: "radio__StyledRadio"
})(["padding:2.5px 10px;&:hover{background-color:transparent;}"]);
var baseIconCSS = (0, _styledComponents.css)(["border-radius:50%;width:16px;height:16px;"]);
var UncheckedIcon = _styledComponents["default"].span.withConfig({
  displayName: "radio__UncheckedIcon"
})(["", ";background-color:", ";border:1px solid #b1b1b1;"], baseIconCSS, _constants.colors.white);
var CheckedIcon = _styledComponents["default"].span.withConfig({
  displayName: "radio__CheckedIcon"
})(["", ";background-color:#3b99fc;border:1px solid #3b99fc;", " &:before{display:block;width:16px;height:16px;background-image:radial-gradient( ", ",", " 28%,transparent 32% );content:'';}"], baseIconCSS, function (_ref) {
  var $disabled = _ref.$disabled;
  return $disabled && "opacity: 0.5;";
}, _constants.colors.white, _constants.colors.white);
var labelPlacementToMuiLabelPlacement = {
  top: 'Top',
  right: 'End',
  bottom: 'Bottom',
  left: 'Start'
};
function Radio(props) {
  return /*#__PURE__*/React.createElement(_FormControlLabel["default"], (0, _extends2["default"])({}, props, {
    label: /*#__PURE__*/React.createElement(_typography["default"], {
      type: "p"
    }, props.label)
    // @ts-expect-error - TS2322 - Type '"Top" | "End" | "Bottom" | "Start"' is not assignable to type '"top" | "bottom" | "end" | "start" | undefined'.
    ,
    labelPlacement: labelPlacementToMuiLabelPlacement[props.labelPlacement || 'right'],
    control: /*#__PURE__*/React.createElement(StyledRadio, (0, _extends2["default"])({}, props, {
      disableRipple: true,
      color: "default",
      checkedIcon: /*#__PURE__*/React.createElement(CheckedIcon, {
        $disabled: props.disabled
      }),
      icon: /*#__PURE__*/React.createElement(UncheckedIcon, null)
    }))
  }));
}
Radio.defaultProps = {
  disabled: false,
  labelPlacement: 'right'
};
var _default = exports["default"] = Radio;